import isPatientUserId from './isPatientUserId.js';
import { PARTICIPANT_ROLES } from './constants.js';

const isPatientsOnlySession = participants =>
  participants.every(
    ({ userId, reference, roles }) =>
      (roles && [PARTICIPANT_ROLES.ORGANIZER, PARTICIPANT_ROLES.MODERATOR].includes(roles[0])) ||
      (userId && isPatientUserId(userId)) ||
      reference,
  );

export default isPatientsOnlySession;
